// ES 6 Compatibility
export * from "../v1/Plugins/ammoJSPlugin";
